<template>
  <div class="main-body" :style='"height:"+(th+115)+"px"'>
<!--    <div class="header">考核指标名称</div>-->
    <div class="out">

      <div class="search2">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right;">
          <el-input size="mini" placeholder="请输入考核指标名称" v-model="name" clearable style="width:200px;margin-right:5px"></el-input>
          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="考核指标名称" fixed width="200"></el-table-column>
        <el-table-column prop="status" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.checkType == 'Common'">公共考核</span>
            <span v-if="scope.row.checkType == 'Special'">岗位考核</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import SM4 from 'sm-crypto';

export default {
  name: "Page",

  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        console.log("JobClass 需要重加载");
        //this.init();
      }
    }
    else{
      console.log("JobClass 需要重加载");
      //this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },
  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      name:'',

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,

      th:0,

      loading:false,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    dd(){

        const key = SM4.utils.hexStr2Bytes('1234567890abcdef'); // 16字节的密钥，十六进制表示
        const iv = SM4.utils.hexStr2Bytes('abcdef9876543210'); // 16字节的初始向量，十六进制表示
        const encrypted = SM4.ecbEncrypt('1234567', key); // 使用ECB模式加密（你也可以使用CBC模式）
        //this.cipherText = SM4.utils.bytes2HexStr(encrypted); // 将加密后的字节转换为十六进制字符串


    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      let that = this;

      that.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckName/AdmPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          name:this.name,
        }
      }).then( (response)=> {
        //console.log(response);
        that.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        that.loading = false;
        console.log(error);
      });
    },






  }
}
</script>

